import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import chakraview from "../assets/img/chakraview.PNG";
import CentauriResearch from "../assets/img/centauri-research.PNG";
import CentauriTechnologies from "../assets/img/centauri-technologies.PNG";
import Tantoh from "../assets/img/tantoh.PNG";
import kngex from "../assets/img/kngex.PNG";
import school from "../assets/img/school.PNG";
import ecommerce from "../assets/img/ecommerce.PNG";
import expenseTracker from "../assets/img/expense-tracker.PNG";
import mailBox from "../assets/img/mail-box.PNG";
import portfolio from "../assets/img/portfolio.PNG";


import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projectsHTML = [
    {
      title: "chakraview",
      // description: "Design & Development",
      imgUrl: chakraview,
      projectUrl:"https://www.chakraview.co.in/"
    },
    {
      title: "Centauri Research",
      // description: "Design & Development",
      imgUrl: CentauriResearch,
      projectUrl:"https://www.centauri-research.com/"

    },
    {
      title: "Centauri Technologies",
      // description: "Design & Development",
      imgUrl: CentauriTechnologies,
      projectUrl:"https://www.centauri-technologies.com/"

    },
    {
      title: "Tantoh",
      // description: "Design & Development",
      imgUrl: Tantoh,
      projectUrl:"https://www.tantoh.com/"

    },
    {
      title: "Know & Grow Exclusive",
      // description: "Design & Development",
      imgUrl: kngex,
      projectUrl:"http://kngex.com/"

    },
    {
      title: "School Sample ",
      // description: "Design & Development",
      imgUrl: school,
      projectUrl:"https://schools.ajayprajapati.com/school1/index.html"

    },
  ];


  const projectsREACT = [
    {
      title: "ecommerce with cart functionality",
      // description: "Design & Development",
      imgUrl: ecommerce,
      projectUrl:"https://react-ecommerce.ajayprajapati.com/"
    },
    {
      title: "expense tracker",
      // description: "Design & Development",
      imgUrl: expenseTracker,
      projectUrl:"https://react-expense-tracker.ajayprajapati.com/"

    },
    {
      title: "Mail box client",
      // description: "Design & Development",
      imgUrl: mailBox,
      projectUrl:"https://react-mailbox-client.ajayprajapati.com/"

    }, 
    {
      title: "portfolio website",
      // description: "Design & Development",
      imgUrl: portfolio,
      projectUrl:"https://ajayprajapati.com/"

    },  
  
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Here is the links of some of my projects</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">HTML/CSS</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">REACT</Nav.Link>
                    </Nav.Item>
                    
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projectsHTML.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <Row>
                        {
                          projectsREACT.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    
                 
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
